import request from "../utils/wxShare/wxRequest";

export function getShare(params) {
  return request({
    url: "/api/WinXinshare/WeiXinshare",
    method: "get",
    params
  })
}
